import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { PageSkeleton } from "./Page";

export interface ButtonFields {
    title: EntryFieldTypes.Symbol;
    actionType: EntryFieldTypes.Symbol<"Book a call" | "Navigate" | "Start a quote">;
    url?: EntryFieldTypes.Symbol;
    page?: EntryFieldTypes.EntryLink<PageSkeleton>;
}

export type ButtonSkeleton = EntrySkeletonType<ButtonFields, "button">;
export type Button<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<ButtonSkeleton, Modifiers, Locales>;

export function isButton<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is Button<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'button'
}
